import { useTranslation } from 'react-i18next'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { paths } from '@/utils/path'
import { getMappingContractSampleForProduct } from '../../services'
import { SampleContract } from '../../types'
import ContractPartnerButtons from '../../shared/Buttons'
import { useSampleList } from '../../hooks/use-sample-list'

const List = () => {
    const { t } = useTranslation()

    const { data: mappingOptions } = useQueryWithHandler(
        {
            queryKey: [QUERY_KEYS.CONTRACTS_SAMPLES_MAPPING],
            queryFn: getMappingContractSampleForProduct,
        },
        { showLoading: false, showError: false }
    )

    const options = mappingOptions || []

    const {
        contracts,
        columns,
        actions,
        expandable,
        pagination,
        params,
        searchInputProps,
        renderState,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useSampleList(options)

    const stateComponent = renderState()

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.customerContractList,
                        title: t('contract-samples'),
                    },
                ]}
                components={[<ContractPartnerButtons.Create />]}
            />

            <Paper className="space-y-2 mt-2">
                {stateComponent || (
                    <DataTableCustomized<SampleContract>
                        columns={columns}
                        rows={contracts}
                        rowKey={(row) => row.contract_id}
                        size="small"
                        resizable
                        actions={actions}
                        expandable={expandable}
                        toolbar={{
                            search: searchInputProps,
                            settings: {
                                show: true,
                                storageKey: 'contract-samples',
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                        stickyHeader={{
                            enabled: true,
                            offsetTopSelector: '#main-header',
                        }}
                    />
                )}
            </Paper>
        </>
    )
}

export default List
